<template>
  <el-dialog :title="editing?'编辑作品':'录入作品'" :visible="visible" width="520px" :close-on-click-modal="!saving" :close-on-press-escape="!saving" :show-close="!saving" @close="reset">
    <el-form :model="form" label-width="90px" :disabled="saving">
      <el-form-item label="平台"><el-select v-model="form.platform"><el-option label="B站" value="bilibili"/><el-option label="抖音" value="douyin"/></el-select></el-form-item>
      <el-form-item label="作品链接"><el-input v-model="form.source_url"/></el-form-item>
      <el-form-item label="作品编号"><el-input v-model="form.source_id"/></el-form-item>
      <el-form-item label="作品标题"><el-input v-model="form.title"/></el-form-item>
      <el-form-item label="发布时间"><el-date-picker v-model="form.published_at" type="datetime" value-format="yyyy-MM-ddTHH:mm:ss"/></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :disabled="saving" @click="reset">取消</el-button>
      <el-button type="primary" :loading="saving" @click="save">{{saving?'保存中':'保存'}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'

const empty = () => ({ platform: 'bilibili', source_id: '', source_url: '', title: '', published_at: '' })

export default {
  props: ['visible', 'editing'],
  data () { return { form: empty(), saving: false } },
  watch: { visible (value) { if (value) this.form = this.editing ? { ...this.editing } : empty() } },
  methods: {
    reset () {
      if (this.saving) return
      this.form = empty()
      this.$emit('update:visible', false)
    },
    async save () {
      if (this.saving) return
      if (!this.form.source_url || !this.form.title) return this.$message.warning('请填写作品链接和标题')
      this.saving = true
      try {
        if (this.editing) await yuqingApi.put(`creator-content/${this.editing.id}/metadata`, { title: this.form.title, published_at: this.form.published_at || undefined })
        else await yuqingApi.post('creator-content', this.form)
        this.$message.success(this.editing ? '作品资料已保存' : '作品已录入')
        this.saving = false
        this.reset()
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || '作品保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
